import { BaseItem } from "@algolia/autocomplete-core";
import { ReactNode } from "react";

type Props<TItem extends BaseItem = BaseItem> = {
    item?: TItem;
    children: ReactNode;
};

export const ItemWrapper = <TItem extends BaseItem = BaseItem>({
    item: _item,
    children
}: Props<TItem>) => {
    return <li>{children}</li>;
};
